/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Mk_Sol_Problems_TitleInputs */

const en_mk_sol_problems_title = /** @type {(inputs: Mk_Sol_Problems_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Three things that hold ${i?.name} back`)
};

const id_mk_sol_problems_title = /** @type {(inputs: Mk_Sol_Problems_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tiga hal yang menahan ${i?.name}`)
};

/**
* | output |
* | --- |
* | "Three things that hold {name} back" |
*
* @param {Mk_Sol_Problems_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_problems_title = /** @type {((inputs: Mk_Sol_Problems_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Problems_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_problems_title(inputs)
	return en_mk_sol_problems_title(inputs)
});